import { ScheduleDescriptionApi } from '@apps/rept/api/models/schedule-description-api';

import { TemplateVersion } from '@apps/rept/rept.constants';

import { Report, ShortRecipient } from '../../domain/models';

export class ReportApi
{
    public reportId: string;
    public active: boolean;
    public createdAt: string;
    public modifiedAt: string;
    public entityId: string;
    public name: string;
    public templateId: string;
    public templateName: string;
    public description: string;
    public cultureName?: string;
    public isContractual: boolean;
    public externalRecipients: ShortRecipient[] = [];
    public internalRecipients: string[] = [];
    public scheduleDescription: ScheduleDescriptionApi;
    public averageGenDuration: string;
    public averageFullDuration: string;
    public version: TemplateVersion;

    public static mapperToApi (source: Report): ReportApi
    {
        const target = new ReportApi();

        Object.assign(target.scheduleDescription, source.scheduleDescription);

        target.reportId = source.reportId;
        target.name = source.name;
        target.cultureName = source.cultureName;
        target.internalRecipients = [...source.internalRecipients];
        target.externalRecipients = [...source.externalRecipients];
        target.isContractual = source.isContractual;

        return target;
    }
}
